module.exports = "/_next/static/images/game-2-menu-social-slide-3-fd26e2a82996e603a1403256af5a70c2.png";